<div
  class="flex flex-col bg-surface-100 z-10 relative h-full w-72 transition-all duration-300"
  [class.w-16!]="!isOpen()"
  [class.shadow-lg]="!isOpen()"
>
  <div class="border-b border-gray-200 p-1 flex items-center justify-center">
    @if (isOpen()) {
      <div class="flex-1"></div>
      <p-button
        icon="pi pi-angle-double-right"
        (click)="toggle()"
        variant="text"
        styleClass="text-gray-900!"
      ></p-button>
    } @else {
      <p-button
        icon="pi pi-angle-double-left"
        (click)="toggle()"
        variant="text"
        styleClass="text-gray-900!"
      ></p-button>
    }
  </div>
  <ng-container *ngTemplateOutlet="navigationDrawer"></ng-container>
</div>
<div class="md:hidden">
  <p-drawer [(visible)]="isOpenMobile" position="right" appendTo="body">
    <ng-container *ngTemplateOutlet="navigationDrawer"></ng-container>
  </p-drawer>
</div>
<ng-template #navigationDrawer>
  <!-- nav items -->
  <div class="flex flex-col flex-1">
    @for (item of items(); track $index) {
      <div>
        <div
          class="flex justify-center px-[9px] hover:bg-white"
          [class.bg-white]="item.expanded"
        >
          <ng-icon
            name="{{ item.icon }}"
            class="text-primary! my-3! text-xl"
            aria-hidden="true"
            size="1.4rem"
          ></ng-icon>
          @if (isOpen() || isOpenMobile()) {
            <a
              class="flex flex-1 items-center gap-2 p-2!"
              [class.cursor-pointer]="item.data?.link || item.children"
              [class.pointer-events-none]="modalOpen()"
              [class.opacity-50]="modalOpen()"
              [routerLink]="item.data?.link"
              (click)="
                item.data?.link ? null : (item.expanded = !item.expanded)
              "
            >
              <span
                class="text-surface-700 line-clamp-1 overflow-x-clip ms-2"
                >{{ item.label }}</span
              >
            </a>
            @if (item.children) {
              <i
                class="fa-solid fa-chevron-down mr-auto inline-flex! items-center! transition-all"
                [class.rotate-180]="item.expanded"
                (click)="item.expanded = !item.expanded"
              ></i>
            }
          }
        </div>

        @if (item.expanded) {
          <div [@slideDown] class="pr-5">
            @for (subitem of item.children; track $index) {
              <div class="hover:bg-white">
                @if (isArray(subitem.data?.link)) {
                  <a
                    class="flex items-center gap-2 p-2"
                    [class.pointer-events-none]="modalOpen()"
                    [class.opacity-50]="modalOpen()"
                    [routerLink]="subitem.data?.link"
                    (click)="collapseAllItems()"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        subitemLabel;
                        context: {
                          $implicit: subitem,
                        }
                      "
                    ></ng-container>
                  </a>
                } @else {
                  <a
                    class="flex items-center gap-2 p-2"
                    [class.pointer-events-none]="modalOpen()"
                    [class.opacity-50]="modalOpen()"
                    [href]="subitem.data?.link"
                    target="_blank"
                    (click)="collapseAllItems()"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        subitemLabel;
                        context: {
                          $implicit: subitem,
                        }
                      "
                    ></ng-container>
                  </a>
                }
                <ng-template #subitemLabel let-subitem>
                  <i
                    class="{{ subitem.icon }} text-primary"
                    aria-hidden="true"
                  ></i>
                  <span class="text-surface-700">{{ subitem.label }}</span>
                </ng-template>
              </div>
            }
          </div>
        }
      </div>
    }
    <div class="mt-auto"></div>
    <p-divider class="my-1!" />
    <div class="flex items-center p-3! cursor-pointer text-primary!">
      <ng-icon
        name="lucidePhone"
        aria-hidden="true"
        size="1.4rem"
        class="mx-2"
      ></ng-icon>
      @if (isOpen() || isOpenMobile()) {
        <span
          class="text-surface-700 line-clamp-1 overflow-x-clip ms-2"
          (click)="callSupportExpanded.set(!callSupportExpanded())"
          >تماس با پشتیبانی
        </span>
      }
    </div>
    @if (callSupportExpanded()) {
      <div [@slideDown] class="p-3!">
        <a href="tel:+02191002372" class="text-blue-600"
          >02191002372
          <span class="fa fa-link"></span>
        </a>
      </div>
    }
    <button
      class="flex items-center p-3! cursor-pointer text-primary!"
      (click)="logout()"
    >
      <ng-icon
        name="lucideLogOut"
        class="mx-2"
        aria-hidden="true"
        size="1.4rem"
      ></ng-icon>
      @if (isOpen() || isOpenMobile()) {
        <span class="text-surface-700 line-clamp-1 overflow-x-clip ms-2"
          >خروج</span
        >
      }
    </button>
    <div class="h-4"></div>
  </div>
</ng-template>
